import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import { getProductivityStats, getNitrogenLossStats } from '../../lib/api';
import { getFormattedStats, sortDistribution } from '../../lib/charts';
import ApexChart from '../../components/Chart';
import DraggableModal from '../../components/DraggableModal';
import { getChartColors } from '../../services/chart-colors';

const FieldDetails = ({ field, handleClose }) => {
  const [productivityStatsLoading, setProductivityStatsLoading] =
    useState(false);
  const [productivityStats, setProductivityStats] = useState(null);
  const [nitrogenLossStatsLoading, setNitrogenLossStatsLoading] =
    useState(false);
  const [nitrogenLossStats, setNitrogenLossStats] = useState(null);
  const [currentTab, setCurrentTab] = useState(0);
  const [showPPStats, setShowPPStats] = useState(false);
  const [showNLStats, setShowNLStats] = useState(false);

  useEffect(() => {
    setProductivityStatsLoading(true);
    getProductivityStats(field.aaManagedId)
      .then((stats) => {
        if (!stats || !stats.stats) {
          setProductivityStatsLoading(false);
          return;
        }
        stats.distribution = sortDistribution(stats.distribution);
        if (stats.stats.max > 0) setShowPPStats(true);
        const cArr = getChartColors('potential-productivity');
        const formattedStats = getFormattedStats(stats, cArr);
        setProductivityStats(formattedStats);
        setProductivityStatsLoading(false);
      })
      .catch(() => {
        setProductivityStatsLoading(false);
      });
  }, [field]);

  useEffect(() => {
    setNitrogenLossStatsLoading(true);
    getNitrogenLossStats(field.aaManagedId)
      .then((stats) => {
        if (!stats || !stats.stats) {
          setNitrogenLossStatsLoading(false);
          return;
        }
        stats.distribution = sortDistribution(stats.distribution);
        if (stats.stats.max > 0) setShowNLStats(true);
        const cArr = getChartColors('nitrogen-loss');
        const formattedStats = getFormattedStats(stats, cArr);
        setNitrogenLossStats(formattedStats);
        setNitrogenLossStatsLoading(false);
      })
      .catch(() => {
        setNitrogenLossStatsLoading(false);
      });
  }, [field]);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const tabsToShow = () => (
    <Tabs value={currentTab} onChange={handleTabChange}>
      {showPPStats && <Tab label="Productivity" />}
      {showNLStats && <Tab label="Nitrogen Loss" />}
    </Tabs>
  );

  return (
    <DraggableModal
      handleClose={handleClose}
      isLoading={nitrogenLossStatsLoading || productivityStatsLoading}
      title={`${field.fieldName} Potential Productivity`}
    >
      {tabsToShow()}

      {currentTab === 0 && productivityStats && showPPStats && (
        <Box>
          <ApexChart
            xLabel="Productivity"
            yLabel="Acres"
            stats={productivityStats}
          />
        </Box>
      )}

      {((currentTab === 0 && nitrogenLossStats && !showPPStats) ||
        (currentTab === 1 && nitrogenLossStats)) && (
        <Box>
          <ApexChart
            xLabel="NitrogenLoss"
            yLabel="Acres"
            stats={nitrogenLossStats}
          />
        </Box>
      )}
    </DraggableModal>
  );
};

export default FieldDetails;
